import Events from '../../utilities/EventEmitter';
import { APP_EVENT_NAMES } from '../constants';
const { IBPLANNING } = APP_EVENT_NAMES;
// Dynamic Routing
export const dynamicRoutingCompleted = (
  scenarioId,
  terminalCode,
  totalRoutes,
  totalStops,
  lgRoutes,
  anchorPointsCount,
  totalMiles,
  trailerTypesCount,
  unroutedShipments,
  cityRoutes,
  otherRoutes
) => {
  console.log('Dynamic Routing Completed for scenario: ', scenarioId);
  Events.emit(IBPLANNING.RoutingStatus, scenarioId, true, null, {
    terminalCode,
    totalRoutes,
    totalStops,
    lgRoutes,
    anchorPointsCount,
    totalMiles,
    trailerTypesCount,
    unroutedShipments,
    cityRoutes,
    otherRoutes
  });
};

export const dynamicRoutingFailed = (scenarioId) => {
  Events.emit(IBPLANNING.RoutingStatus, scenarioId, false);
};

export const routingProgress = (scenarioId, percentCompleted) => {
  console.log('Routing Progress for scenario id: ', scenarioId, percentCompleted);
  Events.emit(IBPLANNING.RoutingStatus, scenarioId, true, percentCompleted);
};

//Route Publish
export const routePublishCompleted = (scenarioId, terminalCode) => {
  console.log('Routes data published for scenario: ', scenarioId);
  Events.emit(IBPLANNING.RoutePublishCompleted, scenarioId, terminalCode, true);
};

export const routePublishFailed = (scenarioId, terminalCode) => {
  console.log('Routes data publish failed for scenario: ', scenarioId);
  Events.emit(IBPLANNING.RoutePublishCompleted, scenarioId, terminalCode, false);
};

//ETL
export const etlStarted = (scenarioId, terminalCode, isFirstPush, planDate) => {
  console.log('ETL running for scenario: ', scenarioId, terminalCode, isFirstPush, planDate);
  Events.emit(
    IBPLANNING.ETLProgress,
    'started',
    scenarioId,
    terminalCode,
    false,
    isFirstPush,
    planDate
  );
};

export const etlCompleted = (scenarioId, terminalCode, isFirstPush, planDate, etlSummary) => {
  console.log(
    'ETL completed for scenario: ',
    scenarioId,
    terminalCode,
    isFirstPush,
    planDate,
    etlSummary
  );
  Events.emit(
    IBPLANNING.ETLProgress,
    'completed',
    scenarioId,
    terminalCode,
    true,
    isFirstPush,
    planDate,
    etlSummary
  );
};

export const etlFailed = (scenarioId, terminalCode, isFirstPush, planDate) => {
  console.log('ETL failed for scenario: ', scenarioId, terminalCode, isFirstPush, planDate);
  Events.emit(
    IBPLANNING.ETLProgress,
    'completed',
    scenarioId,
    terminalCode,
    false,
    isFirstPush,
    planDate
  );
};

export const shipmentDetected = (terminalCode,planDate) => {
  console.log("New Shipments Detected");
  Events.emit(IBPLANNING.NewShipmentsDetected, terminalCode, planDate);
}
